import Icon from 'component/ui/Icon';
import styled, { css } from 'styled-components';

import { ITooltipIconPositionProps, ITooltipIconPropsContext } from './types';

/**
 * Small 'i' svg icon for anchoring tooltip with info related to
 * dashboard panel content.
 *
 * @param $iconColor - color of the icon
 * @param $iconDisplay = css display value
 * @param $iconHoverColor - color of the icon on hover
 * @param $iconHoverOpacity - opacity of icon on hover.  Useful when
 *  used over a dark color back ground.  Set color to #fff and then
 *  opacity to 0.5 or near and it will appear a lighter shade of its parent
 *  background
 *
 * @param top - relative positioning props.  Default is top right.
 * @param right
 * @param bottom
 * @param left
 *
 * @param data-for - used by the tooltip component - id of tooltip element
 *  where tooltip content lives
 * @param data-tip - content displayed by the tooltip on hover over the icon
 */
const DashboardPanelTooltipIcon = styled(Icon)<ITooltipIconPropsContext>`
  position: absolute;
  ${({ top, left, right, bottom }: ITooltipIconPositionProps) => {
    return css`
      top: ${top};
      right: ${right};
      left: ${left};
      bottom: ${bottom};
    `;
  }}
  transition: opacity 150ms ease-in-out, color 150ms ease-in-out;

  width: 14px;
  height: 14px;
  color: ${({ $iconColor }) => $iconColor};
  display: ${({ $iconDisplay }) => $iconDisplay};

  &:hover {
    color: ${({ $iconHoverColor }) => $iconHoverColor};
    opacity: ${({ $iconHoverOpacity }) => $iconHoverOpacity};
  }
`;

/**
 * These defaults apply a top right positioning relative
 * to the container - and are relied upon by the SummaryCards
 */
DashboardPanelTooltipIcon.defaultProps = {
  $iconColor: '#ccc',
  $iconHoverColor: '#42526e',
  $iconHoverOpacity: 1,
  top: '4px',
  right: '6px',
};

export default DashboardPanelTooltipIcon;

export * from './types';
